import { useAuth0 } from "@auth0/auth0-react"

import { Box, Button, ButtonText, Text, VStack } from "wealthmode-frontend/gluestack/ui"

export default function Login() {
  const { loginWithRedirect } = useAuth0()

  return (
    <div className="bg-background-primary min-h-screen flex items-center justify-center">
      <Box className="w-full max-w-md mx-auto px-4">
        <VStack className="items-center gap-6">
          <VStack className="items-center gap-2">
            <Text className="text-3xl font-bold text-foreground-primary">Wealthmode</Text>
            <Text className="text-foreground-tertiary">Admin Dashboard</Text>
          </VStack>
          <Button
            size="lg"
            action="primary"
            className="bg-background-contrast w-full"
            onPress={() => loginWithRedirect()}
          >
            <ButtonText className="text-foreground-contrast">Log In</ButtonText>
          </Button>
        </VStack>
      </Box>
    </div>
  )
}
